import type { CrudColumnDef } from "@/components/tables/crudColumnDef";
import { getMrtColumnId } from "@/components/tables/genericCrudTable.listParams";
import type { EntityAdapter } from "@/components/tables/entityAdapters/entityAdapter";

export const getSearchFieldPlaceholder = (
  t: (key: string) => string,
  entityAdapter?: EntityAdapter
): string => entityAdapter?.searchPlaceholder?.(t) ?? t("search_placeholder");

export const getSearchFieldAutoFocus = (entityAdapter?: EntityAdapter): boolean =>
  entityAdapter?.searchAutoFocus ?? true;

export const getRowBackgroundColor = (
  row: { index: number; original: Record<string, any> },
  entityAdapter?: EntityAdapter
): string => {
  const entityColor = entityAdapter?.rowBackgroundColor?.(row);
  if (entityColor) {
    return entityColor;
  }
  return row.index % 2 === 0 ? "#f5f5f5" : "#FFF";
};

export const getBodyCellSx = (
  rowData: Record<string, any>,
  baseSx: Record<string, unknown>,
  entityAdapter?: EntityAdapter
): Record<string, unknown> =>
  entityAdapter?.bodyCellSx?.(rowData, baseSx) || baseSx;

export const getTableCellWhiteSpace = (entityAdapter?: EntityAdapter): string =>
  entityAdapter?.cellWhiteSpace ?? "";

export const getColumnVisibilityHiddenByDefault = (
  columns: CrudColumnDef[]
): Record<string, boolean> => {
  const columnVisibility: Record<string, boolean> = {};
  for (const column of columns) {
    const columnId = getMrtColumnId(column);
    if (column.hiddenByDefault && columnId) {
      columnVisibility[columnId] = false;
    }
  }
  return columnVisibility;
};
